<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    modal
    header="Массовое редактирование"
    :style="{ width: '900px' }"
    :closable="!applying"
    class="bulk-edit-dialog"
  >
    <div class="bulk-edit-content">
      <!-- Шаг 1: Фильтры для выбора товаров -->
      <div class="step-section mb-4">
        <div class="step-header mb-3">
          <span class="step-number">1</span>
          <span class="step-title">Выберите товары для редактирования</span>
        </div>
        
        <!-- Основные фильтры -->
        <div class="grid">
          <div class="col-12 md:col-4">
            <label class="block text-600 text-sm mb-1">Бренд</label>
            <Dropdown
              v-model="filters.brand"
              :options="brandOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все бренды"
              class="w-full"
              filter
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-12 md:col-4">
            <label class="block text-600 text-sm mb-1">Категория</label>
            <Dropdown
              v-model="filters.category"
              :options="categoryOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все категории"
              class="w-full"
              filter
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-12 md:col-4">
            <label class="block text-600 text-sm mb-1">Статус</label>
            <Dropdown
              v-model="filters.status"
              :options="statusOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все статусы"
              class="w-full"
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-12 md:col-4">
            <label class="block text-600 text-sm mb-1">Состояние</label>
            <Dropdown
              v-model="filters.condition"
              :options="conditionOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все состояния"
              class="w-full"
              filter
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-12 md:col-4">
            <label class="block text-600 text-sm mb-1">Статус на сайте</label>
            <Dropdown
              v-model="filters.site_status"
              :options="siteStatusOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все статусы"
              class="w-full"
              filter
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-6 md:col-2">
            <label class="block text-600 text-sm mb-1">Новинка</label>
            <Dropdown
              v-model="filters.is_new"
              :options="flagOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все"
              class="w-full"
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-6 md:col-2">
            <label class="block text-600 text-sm mb-1">Бестселлер</label>
            <Dropdown
              v-model="filters.is_bestseller"
              :options="flagOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все"
              class="w-full"
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-6 md:col-2">
            <label class="block text-600 text-sm mb-1">Rx</label>
            <Dropdown
              v-model="filters.is_rx"
              :options="flagOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все"
              class="w-full"
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-6 md:col-2">
            <label class="block text-600 text-sm mb-1">Polarized</label>
            <Dropdown
              v-model="filters.is_polarized"
              :options="flagOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все"
              class="w-full"
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-6 md:col-2">
            <label class="block text-600 text-sm mb-1">Photochrome</label>
            <Dropdown
              v-model="filters.is_photochromic"
              :options="flagOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все"
              class="w-full"
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-12 md:col-4">
            <label class="block text-600 text-sm mb-1">Производитель</label>
            <Dropdown
              v-model="filters.producer"
              :options="producerOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все производители"
              class="w-full"
              filter
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-12 md:col-4">
            <label class="block text-600 text-sm mb-1">Страна</label>
            <Dropdown
              v-model="filters.country"
              :options="countryOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Все страны"
              class="w-full"
              filter
              showClear
              @change="onFilterChange"
            />
          </div>
          <div class="col-12 md:col-4 flex align-items-end">
            <div class="flex align-items-center gap-2 w-full">
              <div v-if="productsCount !== null && hasActiveFilters" class="flex align-items-center gap-2">
                <Tag severity="info" class="px-3">
                  <i class="pi pi-box mr-1"></i>
                  {{ productsCount }} товаров
                </Tag>
              </div>
              <ProgressSpinner v-if="loadingCount" style="width: 24px; height: 24px" strokeWidth="4" />
              <Button 
                v-if="hasActiveFilters"
                icon="pi pi-filter-slash" 
                class="p-button-text p-button-secondary"
                @click="clearFilters"
                v-tooltip.top="'Сбросить фильтры'"
              />
            </div>
          </div>
        </div>
        
        <!-- Подсказка -->
        <div v-if="!hasActiveFilters" class="mt-3 p-3 surface-100 border-round">
          <i class="pi pi-lightbulb text-warning mr-2"></i>
          <span class="text-600">Выберите хотя бы один фильтр для отбора товаров</span>
        </div>
      </div>

      <!-- Шаг 2: Правила редактирования -->
      <div v-if="hasActiveFilters && productsCount > 0" class="step-section mb-4">
        <div class="step-header mb-3">
          <span class="step-number">2</span>
          <span class="step-title">Добавьте правила редактирования</span>
          <span class="text-500 text-sm ml-auto">Добавлено правил: {{ editRules.length }}</span>
        </div>

        <!-- Список правил -->
        <div class="rules-list">
          <TransitionGroup name="rule">
            <div
              v-for="(rule, index) in editRules"
              :key="rule.id"
              class="rule-item mb-3"
            >
              <div class="rule-card p-3">
                <div class="flex align-items-center gap-2 flex-wrap">
                  <!-- Выбор поля -->
                  <div class="field-select" style="min-width: 160px;">
                    <label class="block text-600 text-sm mb-1">Поле</label>
                    <Dropdown
                      v-model="rule.field"
                      :options="getAvailableFields(rule)"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Выберите"
                      class="w-full"
                      @change="onFieldChange(rule)"
                    />
                  </div>

                  <!-- Стрелка -->
                  <div class="arrow-icon mt-3">
                    <i class="pi pi-arrow-right text-primary text-xl"></i>
                  </div>

                  <!-- Режим значения: ввод или копирование -->
                  <div class="value-mode" style="min-width: 130px;">
                    <label class="block text-600 text-sm mb-1">Источник</label>
                    <Dropdown
                      v-model="rule.mode"
                      :options="valueModeOptions"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      @change="onModeChange(rule)"
                    />
                  </div>

                  <!-- Новое значение или выбор поля для копирования -->
                  <div class="value-input flex-1" style="min-width: 180px;">
                    <label class="block text-600 text-sm mb-1">
                      {{ rule.mode === 'copy' ? 'Копировать из поля' : 'Новое значение' }}
                    </label>
                    
                    <!-- Режим копирования из другого поля -->
                    <div v-if="rule.mode === 'copy'" class="p-inputgroup">
                      <Dropdown
                        v-model="rule.sourceField"
                        :options="getCopySourceFields(rule)"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Выберите поле"
                        class="flex-1"
                      />
                    </div>
                    
                    <!-- Для числовых полей -->
                    <InputNumber
                      v-else-if="isNumberField(rule.field)"
                      v-model="rule.newValue"
                      :placeholder="getFieldPlaceholder(rule.field)"
                      class="w-full"
                      :suffix="getFieldSuffix(rule.field)"
                    />
                    
                    <!-- Для полей с предустановленными значениями -->
                    <div v-else-if="hasPresetValues(rule.field)" class="p-inputgroup">
                      <Dropdown
                        v-model="rule.newValue"
                        :options="getPresetValues(rule.field)"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Выбрать или ввести"
                        class="flex-1"
                        :showClear="true"
                        editable
                      />
                      <Button 
                        icon="pi pi-eraser" 
                        class="p-button-secondary"
                        @click="rule.newValue = ''"
                        v-tooltip.top="'Очистить'"
                      />
                    </div>
                    
                    <!-- Для текстовых полей -->
                    <div v-else class="p-inputgroup">
                      <InputText
                        v-model="rule.newValue"
                        :placeholder="getFieldPlaceholder(rule.field)"
                        class="flex-1"
                      />
                      <Button 
                        icon="pi pi-eraser" 
                        class="p-button-secondary"
                        @click="rule.newValue = ''"
                        v-tooltip.top="'Очистить'"
                      />
                    </div>
                  </div>

                  <!-- Кнопка удаления -->
                  <Button
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger mt-3"
                    @click="removeRule(index)"
                    v-tooltip.top="'Удалить'"
                  />
                </div>

                <!-- Предпросмотр текущего значения -->
                <div v-if="rule.field && currentValues[rule.field]" class="current-value-preview mt-2">
                  <small class="text-500">
                    <i class="pi pi-info-circle mr-1"></i>
                    Текущие значения: 
                    <span v-for="(count, value) in limitedCurrentValues(rule.field)" :key="value" class="value-badge">
                      {{ value || '(пусто)' }}: {{ count }}
                    </span>
                    <span v-if="Object.keys(currentValues[rule.field] || {}).length > 5" class="text-400">
                      ...и ещё {{ Object.keys(currentValues[rule.field]).length - 5 }}
                    </span>
                  </small>
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>

        <!-- Кнопки добавления -->
        <div class="flex gap-2 flex-wrap">
          <Button
            label="Добавить правило"
            icon="pi pi-plus"
            class="p-button-outlined p-button-primary"
            :disabled="!canAddMoreRules"
            @click="addRule"
          />
          <Button
            v-if="editRules.length > 0"
            label="Очистить все"
            icon="pi pi-times"
            class="p-button-outlined p-button-secondary"
            @click="clearAllRules"
          />
        </div>
        <small v-if="!canAddMoreRules" class="text-500 block mt-2">
          <i class="pi pi-check-circle mr-1"></i>
          Все доступные поля уже добавлены
        </small>
      </div>

      <!-- Шаг 3: Превью изменений -->
      <div v-if="hasActiveFilters && productsCount > 0 && editRules.length > 0 && hasValidRules" class="step-section mb-4">
        <div class="step-header mb-3">
          <span class="step-number">3</span>
          <span class="step-title">Превью изменений</span>
        </div>

        <div class="preview-card p-3">
          <div class="flex align-items-center justify-content-between mb-3">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-eye text-primary text-xl"></i>
              <span class="font-medium">Будет изменено: </span>
              <Tag :value="`${productsCount} товаров`" severity="warning" class="px-3" />
            </div>
            <Button
              label="Обновить превью"
              icon="pi pi-refresh"
              class="p-button-text p-button-sm"
              :loading="loadingPreview"
              @click="loadPreview"
            />
          </div>

          <!-- Таблица превью -->
          <DataTable
            v-if="previewData.length > 0"
            :value="previewData"
            :rows="5"
            class="p-datatable-sm"
            responsiveLayout="scroll"
          >
            <Column field="part_number" header="Артикул" style="width: 140px">
              <template #body="slotProps">
                <code class="text-sm">{{ slotProps.data.part_number }}</code>
              </template>
            </Column>
            <Column header="Изменения">
              <template #body="slotProps">
                <div class="changes-list">
                  <div v-for="change in slotProps.data.changes" :key="change.field" class="change-item">
                    <span class="field-name">{{ getFieldLabel(change.field) }}:</span>
                    <span class="old-value">{{ change.oldValue || '(пусто)' }}</span>
                    <i class="pi pi-arrow-right mx-2 text-400"></i>
                    <span class="new-value" :class="{ 'text-orange-500': !change.newValue }">
                      {{ change.newValue || '(очистить)' }}
                    </span>
                  </div>
                </div>
              </template>
            </Column>
          </DataTable>

          <div v-else-if="!loadingPreview" class="text-500 text-center py-3">
            <i class="pi pi-info-circle mr-2"></i>
            Нажмите "Обновить превью" для просмотра примера изменений
          </div>
          
          <ProgressSpinner v-if="loadingPreview" style="width: 40px; height: 40px" class="block mx-auto my-3" />
        </div>
      </div>

      <!-- Предупреждения -->
      <div v-if="warnings.length > 0" class="warnings-section mb-4">
        <Message v-for="warning in warnings" :key="warning" severity="warn" :closable="false">
          {{ warning }}
        </Message>
      </div>

      <!-- Прогресс выполнения -->
      <div v-if="applying" class="progress-section mb-4">
        <div class="step-section">
          <div class="flex align-items-center gap-3 mb-3">
            <ProgressSpinner style="width: 24px; height: 24px" strokeWidth="4" />
            <span class="font-medium">Применение изменений...</span>
          </div>
          <ProgressBar :value="progressPercent" :showValue="true" class="mb-2" />
          <small class="text-500">
            Обработано: {{ progressCurrent }} из {{ productsCount }} товаров
          </small>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-content-between w-full">
        <div class="flex gap-2">
          <Button
            label="Сбросить"
            icon="pi pi-refresh"
            class="p-button-text"
            :disabled="applying"
            @click="resetForm"
          />
        </div>
        <div class="flex gap-2">
          <Button
            label="Отмена"
            icon="pi pi-times"
            class="p-button-text"
            :disabled="applying"
            @click="$emit('update:visible', false)"
          />
          <Button
            label="Применить изменения"
            icon="pi pi-check"
            class="p-button-success"
            :loading="applying"
            :disabled="!canApply"
            @click="confirmAndApply"
          />
        </div>
      </div>
    </template>
  </Dialog>

  <!-- Диалог подтверждения -->
  <Dialog
    v-model:visible="showConfirmDialog"
    modal
    header="Подтверждение изменений"
    :style="{ width: '550px' }"
    :closable="!applying"
  >
    <div class="confirmation-content">
      <div class="flex align-items-center mb-4">
        <i class="pi pi-exclamation-triangle text-warning text-4xl mr-3"></i>
        <div>
          <p class="font-medium mb-1">Вы уверены, что хотите применить изменения?</p>
          <p class="text-600 mb-0">
            Будет изменено <strong>{{ productsCount }}</strong> товаров
          </p>
        </div>
      </div>

      <!-- Применённые фильтры -->
      <div class="filters-summary p-3 surface-50 border-round mb-3">
        <p class="font-medium mb-2 text-sm">Фильтры отбора:</p>
        <div class="flex flex-wrap gap-2">
          <Tag v-if="filters.brand" severity="info">Бренд: {{ filters.brand }}</Tag>
          <Tag v-if="filters.category" severity="info">Категория: {{ filters.category }}</Tag>
          <Tag v-if="filters.status" severity="info">Статус: {{ filters.status }}</Tag>
          <Tag v-if="filters.producer" severity="info">Производитель: {{ filters.producer }}</Tag>
          <Tag v-if="filters.country" severity="info">Страна: {{ filters.country }}</Tag>
        </div>
      </div>

      <!-- Предупреждение о пустых значениях -->
      <Message v-if="hasEmptyNewValues" severity="warn" :closable="false" class="mb-3">
        <i class="pi pi-exclamation-circle mr-2"></i>
        Некоторые поля будут очищены (установлены пустые значения)
      </Message>

      <!-- Предупреждение о копировании -->
      <Message v-if="hasCopyRules" severity="info" :closable="false" class="mb-3">
        <i class="pi pi-copy mr-2"></i>
        Значения будут скопированы из других полей
      </Message>

      <div class="changes-summary p-3 surface-100 border-round">
        <p class="font-medium mb-2">Применяемые изменения:</p>
        <ul class="pl-3 mb-0">
          <li v-for="rule in validRules" :key="rule.id" class="mb-1">
            <strong>{{ getFieldLabel(rule.field) }}</strong>: 
            <span v-if="rule.mode === 'copy'" class="text-blue-500">
              <i class="pi pi-copy text-xs mr-1"></i>
              копировать из "{{ getFieldLabel(rule.sourceField) }}"
            </span>
            <span v-else :class="{ 'text-orange-500': !rule.newValue && rule.newValue !== 0 }">
              {{ rule.newValue || rule.newValue === 0 ? rule.newValue : '(очистить)' }}
            </span>
          </li>
        </ul>
      </div>
    </div>

    <template #footer>
      <Button
        label="Отмена"
        icon="pi pi-times"
        class="p-button-text"
        @click="showConfirmDialog = false"
      />
      <Button
        label="Подтвердить и применить"
        icon="pi pi-check"
        class="p-button-danger"
        :loading="applying"
        @click="applyChanges"
      />
    </template>
  </Dialog>
</template>

<script>
import { ref, reactive, computed, watch } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Tag from 'primevue/tag'
import Message from 'primevue/message'
import ProgressSpinner from 'primevue/progressspinner'
import ProgressBar from 'primevue/progressbar'
import { useToast } from 'primevue/usetoast'
import apiService from '../services/apiService'
import { useProductSchema } from '../composables/useProductSchema'

export default {
  name: 'BulkEditDialog',
  components: {
    Dialog,
    Button,
    Dropdown,
    InputText,
    InputNumber,
    DataTable,
    Column,
    Tag,
    Message,
    ProgressSpinner,
    ProgressBar
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    brandOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'changes-applied'],
  setup(props, { emit }) {
    const toast = useToast()
    
    // Расширенные фильтры
    const filters = reactive({
      brand: null,
      category: null,
      status: null,
      condition: null,
      site_status: null,
      is_new: null,
      is_bestseller: null,
      is_rx: null,
      is_polarized: null,
      is_photochromic: null,
      producer: null,
      country: null
    })

    // Опции для фильтров
    const categoryOptions = ref([])
    const statusOptions = [
      { label: 'ACTIVE', value: 'ACTIVE' },
      { label: 'ARCHIVE', value: 'ARCHIVE' }
    ]
    const conditionOptions = ref([])
    const siteStatusOptions = ref([])
    const flagOptions = ref([
      { label: '1 — Да', value: '1' },
      { label: '0 — Нет', value: '0' }
    ])
    const producerOptions = ref([])
    const countryOptions = ref([])
    
    // Состояние
    const productsCount = ref(null)
    const loadingCount = ref(false)
    const editRules = ref([])
    const currentValues = ref({})
    const previewData = ref([])
    const loadingPreview = ref(false)
    const applying = ref(false)
    const showConfirmDialog = ref(false)
    
    // Прогресс
    const progressCurrent = ref(0)
    const progressPercent = computed(() => {
      if (!productsCount.value) return 0
      return Math.round((progressCurrent.value / productsCount.value) * 100)
    })

    // Режимы значения
    const valueModeOptions = [
      { label: 'Ввести', value: 'input' },
      { label: 'Копировать', value: 'copy' }
    ]

    // Источник истины — productSchemaStore (/products/schema).
    // Поля с is_editable_bulk=True попадают сюда автоматически.
    // UI-специфичные суффиксы (' мм' для размеров) и оверрайд presets для gender
    // остаются локальной view-spec — backend о них не знает.
    const { fields: schemaFields } = useProductSchema()

    const _GENDER_PRESETS = ['Мужской', 'Женский', 'Унисекс']
    const _MM_SUFFIX_FIELDS = new Set(['bridge', 'temple_length', 'lens_height'])

    const _toEditableField = (f) => {
      // Спец-локализация для gender (UI-spec, backend знает только канонический английский)
      if (f.key === 'gender') {
        return { value: f.key, label: f.display_name, type: 'preset', presets: _GENDER_PRESETS }
      }
      // Числовые поля
      if (f.data_type === 'number' || f.data_type === 'int' || f.data_type === 'float') {
        const item = { value: f.key, label: f.display_name, type: 'number' }
        if (_MM_SUFFIX_FIELDS.has(f.key)) item.suffix = ' мм'
        return item
      }
      // Поля с фиксированными пресетами (status, флаги — приходят из backend)
      if (f.presets && f.presets.length > 0) {
        return { value: f.key, label: f.display_name, type: 'preset', presets: [...f.presets] }
      }
      // Остальное — текст с автоподсказками
      return { value: f.key, label: f.display_name, type: 'text', hasPresets: true }
    }

    const editableFields = computed(() =>
      schemaFields.value
        .filter((f) => f.is_editable_bulk)
        .map(_toEditableField),
    )

    // Хранилище уникальных значений для автозаполнения
    const fieldUniqueValues = ref({})

    // Вычисляемые свойства
    const hasActiveFilters = computed(() => {
      return filters.brand || filters.category || filters.status || filters.producer || filters.country
        || filters.condition || filters.site_status
        || filters.is_new || filters.is_bestseller || filters.is_rx
        || filters.is_polarized || filters.is_photochromic
    })
    
    const usedFields = computed(() => editRules.value.map(r => r.field).filter(Boolean))
    
    const canAddMoreRules = computed(() => {
      return usedFields.value.length < editableFields.length
    })

    const validRules = computed(() => {
      return editRules.value.filter(r => {
        if (!r.field) return false
        if (r.mode === 'copy') return r.sourceField
        return true
      })
    })

    const hasValidRules = computed(() => validRules.value.length > 0)

    const hasEmptyNewValues = computed(() => {
      return validRules.value.some(r => 
        r.mode !== 'copy' && !r.newValue && r.newValue !== 0
      )
    })

    const hasCopyRules = computed(() => {
      return validRules.value.some(r => r.mode === 'copy')
    })

    const warnings = computed(() => {
      const warns = []
      if (hasEmptyNewValues.value) {
        warns.push('Некоторые поля будут очищены (пустые значения)')
      }
      return warns
    })

    const canApply = computed(() => {
      return hasActiveFilters.value && hasValidRules.value && productsCount.value > 0
    })

    // Методы
    const getAvailableFields = (currentRule) => {
      return editableFields.filter(f => 
        f.value === currentRule.field || !usedFields.value.includes(f.value)
      )
    }

    const getCopySourceFields = (currentRule) => {
      // Можно копировать из любого поля кроме целевого
      return editableFields.filter(f => f.value !== currentRule.field)
    }

    const getFieldLabel = (fieldValue) => {
      const field = editableFields.find(f => f.value === fieldValue)
      return field ? field.label : fieldValue
    }

    const isNumberField = (fieldValue) => {
      const field = editableFields.find(f => f.value === fieldValue)
      return field?.type === 'number'
    }

    const hasPresetValues = (fieldValue) => {
      const field = editableFields.find(f => f.value === fieldValue)
      return field?.type === 'preset' || field?.hasPresets
    }

    const getPresetValues = (fieldValue) => {
      const field = editableFields.find(f => f.value === fieldValue)
      
      if (field?.presets) {
        return field.presets.map(p => ({ label: p, value: p }))
      }
      
      if (fieldUniqueValues.value[fieldValue]) {
        return fieldUniqueValues.value[fieldValue].map(v => ({ 
          label: v || '(пусто)', 
          value: v 
        }))
      }
      
      return []
    }

    const getFieldPlaceholder = (fieldValue) => {
      const field = editableFields.find(f => f.value === fieldValue)
      return field ? `Введите ${field.label.toLowerCase()}` : 'Введите значение'
    }

    const getFieldSuffix = (fieldValue) => {
      const field = editableFields.find(f => f.value === fieldValue)
      return field?.suffix || ''
    }

    const limitedCurrentValues = (fieldName) => {
      const values = currentValues.value[fieldName] || {}
      const entries = Object.entries(values).slice(0, 5)
      return Object.fromEntries(entries)
    }

    const addRule = () => {
      editRules.value.push({
        id: Date.now(),
        field: null,
        mode: 'input',
        newValue: null,
        sourceField: null
      })
    }

    const removeRule = (index) => {
      editRules.value.splice(index, 1)
    }

    const clearAllRules = () => {
      editRules.value = []
      previewData.value = []
    }

    const clearFilters = () => {
      filters.brand = null
      filters.category = null
      filters.status = null
      filters.condition = null
      filters.site_status = null
      filters.is_new = null
      filters.is_bestseller = null
      filters.is_rx = null
      filters.is_polarized = null
      filters.is_photochromic = null
      filters.producer = null
      filters.country = null
      productsCount.value = null
      currentValues.value = {}
    }

    const onFilterChange = async () => {
      if (!hasActiveFilters.value) {
        productsCount.value = null
        currentValues.value = {}
        return
      }

      loadingCount.value = true
      try {
        const response = await apiService.get('/products/bulk-stats', {
          params: {
            brand: filters.brand || undefined,
            category: filters.category || undefined,
            status: filters.status || undefined,
            condition: filters.condition || undefined,
            site_status: filters.site_status || undefined,
            is_new: filters.is_new || undefined,
            is_bestseller: filters.is_bestseller || undefined,
            is_rx: filters.is_rx || undefined,
            is_polarized: filters.is_polarized || undefined,
            is_photochromic: filters.is_photochromic || undefined,
            producer: filters.producer || undefined,
            country: filters.country || undefined
          }
        })
        
        productsCount.value = response.data.count
        currentValues.value = response.data.field_stats || {}
        fieldUniqueValues.value = response.data.unique_values || {}
        
        // Обновляем опции фильтров
        if (response.data.filter_options) {
          categoryOptions.value = (response.data.filter_options.categories || []).map(c => ({ label: c, value: c }))
          producerOptions.value = (response.data.filter_options.producers || []).map(p => ({ label: p, value: p }))
          countryOptions.value = (response.data.filter_options.countries || []).map(c => ({ label: c, value: c }))
          conditionOptions.value = (response.data.filter_options.conditions || []).map(c => ({ label: c, value: c }))
          siteStatusOptions.value = (response.data.filter_options.site_statuses || []).map(c => ({ label: c, value: c }))
        }
      } catch (error) {
        console.error('Error loading stats:', error)
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Не удалось загрузить статистику',
          life: 3000
        })
      } finally {
        loadingCount.value = false
      }
    }

    const onFieldChange = (rule) => {
      rule.newValue = null
      rule.sourceField = null
    }

    const onModeChange = (rule) => {
      rule.newValue = null
      rule.sourceField = null
    }

    const loadPreview = async () => {
      if (!hasActiveFilters.value || !hasValidRules.value) return

      loadingPreview.value = true
      try {
        const updates = {}
        const copyFields = {}
        
        validRules.value.forEach(rule => {
          if (rule.mode === 'copy') {
            copyFields[rule.field] = rule.sourceField
          } else {
            updates[rule.field] = rule.newValue
          }
        })

        const response = await apiService.post('/products/bulk-update/preview', {
          filters: {
            brand: filters.brand || undefined,
            category: filters.category || undefined,
            status: filters.status || undefined,
            condition: filters.condition || undefined,
            site_status: filters.site_status || undefined,
            is_new: filters.is_new || undefined,
            is_bestseller: filters.is_bestseller || undefined,
            is_rx: filters.is_rx || undefined,
            is_polarized: filters.is_polarized || undefined,
            is_photochromic: filters.is_photochromic || undefined,
            producer: filters.producer || undefined,
            country: filters.country || undefined
          },
          updates,
          copy_fields: copyFields
        })
        
        previewData.value = response.data.preview || []
      } catch (error) {
        console.error('Error loading preview:', error)
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: 'Не удалось загрузить превью',
          life: 3000
        })
      } finally {
        loadingPreview.value = false
      }
    }

    const confirmAndApply = () => {
      showConfirmDialog.value = true
    }

    const applyChanges = async () => {
      applying.value = true
      progressCurrent.value = 0
      
      try {
        const updates = {}
        const copyFields = {}
        
        validRules.value.forEach(rule => {
          if (rule.mode === 'copy') {
            copyFields[rule.field] = rule.sourceField
          } else {
            updates[rule.field] = rule.newValue
          }
        })

        const response = await apiService.post('/products/bulk-update', {
          filters: {
            brand: filters.brand || undefined,
            category: filters.category || undefined,
            status: filters.status || undefined,
            condition: filters.condition || undefined,
            site_status: filters.site_status || undefined,
            is_new: filters.is_new || undefined,
            is_bestseller: filters.is_bestseller || undefined,
            is_rx: filters.is_rx || undefined,
            is_polarized: filters.is_polarized || undefined,
            is_photochromic: filters.is_photochromic || undefined,
            producer: filters.producer || undefined,
            country: filters.country || undefined
          },
          updates,
          copy_fields: copyFields
        })

        // Симуляция прогресса для UX
        const totalUpdated = response.data.updated
        const steps = 10
        const stepSize = Math.ceil(totalUpdated / steps)
        
        for (let i = 1; i <= steps; i++) {
          await new Promise(resolve => setTimeout(resolve, 100))
          progressCurrent.value = Math.min(i * stepSize, totalUpdated)
        }

        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: `Обновлено ${response.data.updated} товаров`,
          life: 4000
        })

        showConfirmDialog.value = false
        emit('update:visible', false)
        emit('changes-applied')
        resetForm()
      } catch (error) {
        console.error('Error applying changes:', error)
        toast.add({
          severity: 'error',
          summary: 'Ошибка',
          detail: error.response?.data?.detail || 'Не удалось применить изменения',
          life: 5000
        })
      } finally {
        applying.value = false
        progressCurrent.value = 0
      }
    }

    const resetForm = () => {
      filters.brand = null
      filters.category = null
      filters.status = null
      filters.condition = null
      filters.site_status = null
      filters.is_new = null
      filters.is_bestseller = null
      filters.is_rx = null
      filters.is_polarized = null
      filters.is_photochromic = null
      filters.producer = null
      filters.country = null
      productsCount.value = null
      editRules.value = []
      currentValues.value = {}
      previewData.value = []
      fieldUniqueValues.value = {}
      progressCurrent.value = 0
    }

    // Загружаем опции фильтров при открытии
    const loadFilterOptions = async () => {
      try {
        const response = await apiService.getFilterOptions()
        categoryOptions.value = (response.data.categories || []).map(c => ({ label: c, value: c }))
        producerOptions.value = (response.data.producers || []).map(p => ({ label: p, value: p }))
        countryOptions.value = (response.data.countries || []).map(c => ({ label: c, value: c }))
        conditionOptions.value = (response.data.conditions || []).map(c => ({ label: c, value: c }))
        siteStatusOptions.value = (response.data.site_statuses || []).map(c => ({ label: c, value: c }))
      } catch (error) {
        console.error('Error loading filter options:', error)
      }
    }

    // Следим за открытием/закрытием диалога
    watch(() => props.visible, (newVal) => {
      if (newVal) {
        loadFilterOptions()
      } else {
        setTimeout(resetForm, 300)
      }
    })

    return {
      filters,
      categoryOptions,
      statusOptions,
      conditionOptions,
      siteStatusOptions,
      flagOptions,
      producerOptions,
      countryOptions,
      hasActiveFilters,
      productsCount,
      loadingCount,
      editRules,
      currentValues,
      previewData,
      loadingPreview,
      applying,
      showConfirmDialog,
      progressCurrent,
      progressPercent,
      valueModeOptions,
      editableFields,
      usedFields,
      canAddMoreRules,
      validRules,
      hasValidRules,
      hasEmptyNewValues,
      hasCopyRules,
      warnings,
      canApply,
      getAvailableFields,
      getCopySourceFields,
      getFieldLabel,
      isNumberField,
      hasPresetValues,
      getPresetValues,
      getFieldPlaceholder,
      getFieldSuffix,
      limitedCurrentValues,
      addRule,
      removeRule,
      clearAllRules,
      clearFilters,
      onFilterChange,
      onFieldChange,
      onModeChange,
      loadPreview,
      confirmAndApply,
      applyChanges,
      resetForm
    }
  }
}
</script>

<style scoped>
.bulk-edit-content {
  min-height: 400px;
}

.step-section {
  padding: 1rem;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--primary-color);
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.875rem;
}

.step-title {
  font-weight: 600;
  color: #495057;
}

.rule-card {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  transition: all 0.2s;
}

.rule-card:hover {
  border-color: var(--primary-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.arrow-icon {
  color: #adb5bd;
}

.current-value-preview {
  padding-top: 0.5rem;
  border-top: 1px dashed #e9ecef;
}

.value-badge {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  margin: 0 0.25rem;
  background: #e9ecef;
  border-radius: 4px;
  font-size: 0.75rem;
}

.preview-card {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.changes-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.change-item {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
}

.field-name {
  font-weight: 500;
  margin-right: 0.5rem;
  min-width: 100px;
}

.old-value {
  color: #dc3545;
  text-decoration: line-through;
}

.new-value {
  color: #28a745;
  font-weight: 500;
}

/* Анимация списка правил */
.rule-enter-active,
.rule-leave-active {
  transition: all 0.3s ease;
}

.rule-enter-from,
.rule-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

.confirmation-content {
  line-height: 1.6;
}

.changes-summary ul {
  list-style-type: disc;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
  .rule-card .flex.align-items-center.gap-2.flex-wrap {
    flex-direction: column;
    align-items: stretch !important;
  }
  .rule-card .field-select,
  .rule-card .value-mode,
  .rule-card .value-input {
    min-width: 0 !important;
    width: 100%;
  }
  .arrow-icon {
    display: none;
  }
}
</style>
